interface SetupPendo {
  company: Company;
  locationId: string;
  userId: string;
  email: string;
}
interface Company {
  id: string;
  logoURL: string;
  domain: string;
  name: string;
}
declare global {
  interface Window {
    pendo: any;
  }
}

export function setupPendo(params: SetupPendo) {
  if (params.company?.id) {
    const initOptions = {
      visitor: {
        id: params.userId,
        email: params.email,
        company_id: params.company.id,
      },
      account: {
        id: `${params.company.id}::${params.locationId}`,
      },
    };
    window.pendo && window.pendo.initialize(initOptions);
  }
}

export const emitPendoEvent = (eventName: string, eventProperties: { [key: string]: string }) => {
  if (
    process.env.NODE_ENV === "production" ||
    process.env.NODE_ENV === "staging" ||
    process.env.NODE_ENV === "interop"
  ) {
    if (window.pendo) {
      window.pendo.track(eventName, eventProperties);
    }
  } else {
    console.table({
      "PENDO Object": "[only in dev mode]",
      eventName,
      ...eventProperties,
    });
  }
};
